import { makeAutoObservable } from 'mobx'
import { RootStore } from 'stores'
import { IFilter } from 'types/common'
import { getNotifications, seenAllNotifications } from 'API/notification'
import { countNotifications } from 'API/notification'
import { INotificationWithRelations } from 'interfaces/notification'

class NotificationStore {
  rootStore: RootStore

  isFetching: boolean = false

  countNotifications: number = 0

  notificationFilter: IFilter<INotificationWithRelations> = {}

  notifications: INotificationWithRelations[] = []

  constructor(rootStore: RootStore) {
    makeAutoObservable(this)

    this.rootStore = rootStore
  }

  public setListFilter(filter: IFilter<INotificationWithRelations> = {}): void {
    this.notificationFilter = filter
  }

  public async fetchNotifications(fetchNextPage = false): Promise<void> {
    this.isFetching = true
    const notifications = await getNotifications(this.notificationFilter)
    if (fetchNextPage) {
      this.notifications = [...this.notifications, ...notifications]
    } else {
      this.notifications = notifications
    }
    this.isFetching = false
  }

  public async aggregateCountNotifications(): Promise<void> {
    const notifications = await countNotifications()
    this.countNotifications = notifications
  }

  public async seenAllNotifications(): Promise<void> {
    await seenAllNotifications()
    this.countNotifications = 0
  }
}

export default NotificationStore
